module.exports = __webpack_public_path__ + "static/1b61dcc43af71bdf09715bec33ba5762af47eb485f3bba7bb6aa1f8c6f0a106b-7af411533e90c1ec918443ca30ec12cb.jpeg";